

class Style {

    /**
     * initializes the styles
     * @param {any} config 
     */
     initStyles = (config: any) => {
        const css = `
            .config-header-backgroundColor {
                color: ${config.header.fontColor} !important;
                background-color: ${config.header.backgroundColor} !important;
            }
            .config-app-body-backgroundColor {
                background-color: ${config.app.body.backgroundColor} !important;
            }
            .config-buttonClose-backgroundColor {
                background-color: ${config.buttonClose.backgroundColor} !important;
            }
            .config-scroll-color::-webkit-scrollbar-thumb {
                background-color: ${config.scroll.color} !important;
            }
            .config-containersMetaData {
                background-color: ${config.containersMetaData.backgroundColor} !important;
                color: ${config.containersMetaData.fontColor} !important;
                box-shadow: rgb(${config.containersMetaData.shadowColorRGB} / 10%) 0px 4px 15px 0px, rgb(${config.containersMetaData.shadowColorRGB} / 10%) 0px 1px 2px 0px, rgb(${config.containersMetaData.shadowColorRGB} / 28%) 0px 2px 0px 0px inset !important;
            }
            .config--continueConversation-button {
                background-color: ${config.containersMetaData.containers.startConversation.button.backgroundColor} !important;
                color: ${config.containersMetaData.containers.startConversation.button.fontColor} !important;
                border: 1px solid ${config.containersMetaData.containers.startConversation.button.borderColor} !important;
            }
            .config--continueConversation-button svg {
                fill:  ${config.containersMetaData.containers.startConversation.button.fontColor} !important;
            }
            
            .config--continueConversation-button:hover {
                background-color: ${config.containersMetaData.containers.startConversation.button.hover.backgroundColor} !important;
                color: ${config.containersMetaData.containers.startConversation.button.hover.fontColor} !important;
            }
            .config--continueConversation-button:hover svg {
                fill:  ${config.containersMetaData.containers.startConversation.button.hover.fontColor} !important;
            }
            .config--startConversation-avatars .avatar {
                border-color: ${config.containersMetaData.containers.startConversation.avatars.borderColor} !important;
            }
            .config-msg-send-fragment {
                background-color: ${config.chat.messageSend.backgroundColor} !important;
                color: ${config.chat.messageSend.fontColor} !important;
            }
            .config-msg-receive-fragment {
                background-color: ${config.chat.messageReceive.backgroundColor} !important;
                color: ${config.chat.messageReceive.fontColor} !important;
            }
            .config-loading-color-1 {
                fill: ${config.chat.messageSend.backgroundColor} !important;
            }
            .config-loading-color-2 {
                fill: ${config.chat.messageSend.backgroundColor} !important;
            }
            .config-loading-color-3 {
                fill: ${config.chat.messageSend.backgroundColor} !important;
            }
            .config-user-option:hover {
                background-color: ${config.chat.messageSend.backgroundColor} !important;
                color: ${config.chat.messageSend.fontColor} !important;
            }
            .config-container-continue-conversation:hover {
                background-color: ${config.containersMetaData.containers.continueConversation.itemHoverColor} !important;
            }
            .config-svg-btn-send-path {
                fill: ${config.header.backgroundColor} !important;
            }
            .config-icon-footer:hover path {
                fill: ${config.header.backgroundColor} !important;
            }
            .config-icon-footer-active path {
                fill: ${config.header.backgroundColor} !important;
            }
            
            .config-btn-chat-form-submit {
                background-color: ${config.containersMetaData.containers.startConversation.button.backgroundColor} !important;
                color: ${config.containersMetaData.containers.startConversation.button.fontColor} !important;
                border: 1px solid ${config.containersMetaData.containers.startConversation.button.borderColor} !important;
            }
            .config-btn-chat-form-submit:hover {
                background-color: ${config.containersMetaData.containers.startConversation.button.hover.backgroundColor} !important;
                color: ${config.containersMetaData.containers.startConversation.button.hover.fontColor} !important;
            }
            .config-btn-chat-form-submit path {
                fill: ${config.containersMetaData.containers.startConversation.button.fontColor} !important;
            }
            .config-icon-file-upload-download path {
                fill: ${config.chat.messageSend.fontColor} !important;
                transition: all 2s;
            }
            .config-icon-file-upload-download circle {
                stroke: ${config.chat.messageSend.fontColor} !important;
                transition: all 0.2s;
            }
            .config-container-search-box {
                border: 1px solid ${config.containersMetaData.containers.startConversation.button.borderColor} !important;
            }
            .config-container-search-box svg {
                fill: ${config.containersMetaData.containers.startConversation.button.borderColor} !important;
            }
            .config-container-search-box .config-container-search-name {
                color: ${config.containersMetaData.containers.startConversation.button.borderColor} !important;
            }
            .config-collectionItem-container:hover {
                background-color: ${config.containersMetaData.containers.continueConversation.itemHoverColor} !important;
            }

            ${this.getTransitionStyles()}
        `;
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);

        this.getTransitionStyles();
    }

    /**
     * styles for the containers
     * @returns {string}
     */
    getTransitionStyles = (): string => {
        const totalChilds = 10;
        var css = ``;
        const duration = 0.4;
        var delayedDuration = 0;

        for (let i = 1; i <= totalChilds; i++) {
            delayedDuration += 0.1;
            const _duration = duration + delayedDuration;
            css += `
                .container-main-body-items > .card-item:nth-of-type(${i}) {
                    transition: transform ${_duration}s !important;
                }
            `;
        }
        //console.log(css);
        return css;
    }
}

// export Style class instance (singleton)
export const __style = new Style();